import { useEffect } from "react";

export function Seo({ title, description, path = "/", noindex = false, image }) {
  useEffect(() => {
    document.title = title;
    const set = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag);
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => {
        if (k !== "tag") el.setAttribute(k, v);
      });
      return el;
    };
    set('meta[name="description"]', { tag: "meta", name: "description", content: description });
    set('meta[name="robots"]', {
      tag: "meta",
      name: "robots",
      content: noindex ? "noindex, nofollow" : "index, follow",
    });
    set('link[rel="canonical"]', { tag: "link", rel: "canonical", href: window.location.origin + path });
    set('meta[property="og:title"]', { tag: "meta", property: "og:title", content: title });
    set('meta[property="og:description"]', { tag: "meta", property: "og:description", content: description });
    set('meta[property="og:type"]', { tag: "meta", property: "og:type", content: "website" });
    set('meta[property="og:url"]', { tag: "meta", property: "og:url", content: window.location.origin + path });
    if (image) set('meta[property="og:image"]', { tag: "meta", property: "og:image", content: image });
    set('meta[name="twitter:card"]', { tag: "meta", name: "twitter:card", content: "summary_large_image" });
  }, [title, description, path, noindex, image]);

  return null;
}

export function LocalBusinessSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "TattooParlor",
      name: "ArtPart – René Ghavami",
      description:
        "Privates Tattoostudio in St. Ruprecht an der Raab. Individuelle, dystopische und architektonische Black-and-Grey-Tattoos. Termine nach Vereinbarung.",
      url: window.location.origin,
      image: window.location.origin + "/og-image.jpg",
      address: {
        "@type": "PostalAddress",
        addressLocality: "St. Ruprecht an der Raab",
        postalCode: "8181",
        addressRegion: "Steiermark",
        addressCountry: "AT",
      },
      areaServed: ["St. Ruprecht an der Raab", "Weiz", "Gleisdorf", "Graz", "Steiermark"],
      priceRange: "$$",
      founder: { "@type": "Person", name: "René Ghavami", jobTitle: "Tätowierer" },
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "artpart-ld";
    script.text = JSON.stringify(data);
    document.head.querySelector("#artpart-ld")?.remove();
    document.head.appendChild(script);
    return () => document.head.querySelector("#artpart-ld")?.remove();
  }, []);
  return null;
}
